import script from "./users-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./users-table.vue?vue&type=script&setup=true&lang=ts"

import "./users-table.vue?vue&type=style&index=0&id=81369156&lang=scss"

const __exports__ = script;

export default __exports__